export enum ReviewEntityScopeEnum {
    brand = 'brand',
    company = 'company',
}

export type ReviewBrandCompanyScopeFieldNamesType = {
    entityScope: string;
    brand: string;
    company: string;
};
